import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { FunctionComponent } from 'react';

import OnDemand from '../../@types/OnDemand';
import EpisodeRow from './EpisodeRow';

interface EpisodeListProps {
  items: OnDemand.SlimEpisode[];
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      '& > :nth-child(n+2)': {
        marginTop: theme.spacing(1),
      },
    },
  });
});

const EpisodeList: FunctionComponent<EpisodeListProps> = (props) => {
  const classes = useStyles(props);
  const { items } = props;

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className={classes.root}>
      {
        items.map((item) => {
          return (
            <EpisodeRow
              key={item.id}
              slimEpisode={item}
            />
          );
        })
      }
    </div>
  );
};

export default EpisodeList;
